define('app/controllers/generic',['require', 'angular', 'json!mdactions.json', 'app/services/shared'], function (require) {
    var angular = require('angular');
    var module = angular.module('app.generic', ['app.shared']);
    module.directive('checkValue', ['$http', '$httpParamSerializer', '$interpolate', function ($http, $httpParamSerializer, $interpolate) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    elem.bind('blur', function () {
                        scope.$apply(function () {
                            var url = attrs['checkValue'];
                            $http.get(url).then(function (response) {
                                angular.forEach(response.data.Ok, function (val) {
                                    ctrl.$setValidity(val, true);
                                });
                                angular.forEach(response.data.Ko, function (val) {
                                    ctrl.$setValidity(val, false);
                                });
                            }, function errorCallback(data) {
                                console.log(data);
                            });
                        });
                    });
                }
            };
        }]);
    module.factory('columnFactory', ['$http', 'apiRoot', function ($http, apiRoot) {
            var serveis = {
                complementColumns: function (info, values) {
                    var columns = [];
                    angular.forEach(info.columns, function (value) {
                        if (value.active && value.ext) {
                            columns.push(value.name);
                        }
                    });
                    if (columns.length == 0)
                        return;
                    var isInt = info['isInt'];
                    var ids = [];
                    if (angular.isArray(values)) {
                        for (var i = 0; i < values.length; i++) {
                            ids.push(isInt ? parseInt(values[i].Id) : values[i].Id);
                        }
                    }
                    else {
                        ids.push(isInt ? parseInt(values.Id) : values.Id);
                    }
                    var url = apiRoot + 'columns/' + info.keyType + '/' + info.name;
                    return $http.post(url, { Columns: columns, Ids: ids }).then(function (response) {
                        angular.forEach(response.data, function (value, key) {
                            angular.forEach(values, function (subValue, subKey) {
                                if (value.hasOwnProperty(subValue.Id)) {
                                    subValue[key] = value[subValue.Id];
                                }
                            });
                        }, values);
                    });
                }
            };
            return serveis;
        }]);
    module.config(['$routeProvider', function ($routeProvider) {
            var resources = require('json!mdactions.json');
            angular.forEach(resources, function (resource) {
                var isInt = resource.keyType === 'I';
                resource['isInt'] = isInt;
                resource['allData'] = resources;
                angular.forEach(resource.columns, function (value) {
                    value['_active'] = value.active;
                });
                var anyWithPerItem = false;
                angular.forEach(resource.actions, function (action, action_name) {
                    action['id'] = action_name;
                    action['isInt'] = isInt;
                    action['active'] = false;
                    if (action.enablePolicy === 'allways') {
                        action['active'] = true;
                    }
                    else if (action.enablePolicy === 'never') {
                        action['active'] = false;
                    }
                    else if (action.enablePolicy === 'perItem') {
                        action['active'] = true;
                        anyWithPerItem = true;
                    }
                });
                resource['actionsPerItem'] = anyWithPerItem;
                angular.forEach(resource.states, function (state, state_name) {
                    state['name'] = state_name;
                    state['parent'] = resource;
                    if (state.querys && !state.elems) {
                        var elems_1 = [];
                        angular.forEach(state.querys, function (queryName) {
                            if (!angular.isUndefined(resource.querys[queryName])) {
                                elems_1.push({ name: queryName, url: resource.querys[queryName] });
                            }
                            else {
                                console.log('Query ' + queryName + ' not found in query collection of ' + resource.title);
                            }
                        });
                        state.elems = elems_1;
                    }
                    var elemActions = [];
                    angular.forEach(state.elemActions, function (actionName) {
                        if (!angular.isUndefined(resource.actions[actionName])) {
                            elemActions.push(resource.actions[actionName]);
                        }
                        else {
                            console.log('Action ' + actionName + ' not found in actions collection of ' + resource.title);
                        }
                    });
                    state['elemActions'] = elemActions;
                    var actions = [];
                    angular.forEach(state.actions, function (actionName) {
                        if (!angular.isUndefined(resource.actions[actionName])) {
                            actions.push(resource.actions[actionName]);
                        }
                        else {
                            console.log('Action ' + actionName + ' not found in actions collection of ' + resource.title);
                        }
                    });
                    state['actions'] = actions;
                    $routeProvider.when(state.route, {
                        reloadOnSearch: false,
                        templateUrl: state.template,
                        controller: state.controller,
                        resolve: {
                            consumer: ['$injector', function ($injector) { return $injector.get(state.consumer || 'globalService'); }],
                            state: function () { return state; },
                            info: function () { return resource; },
                            elem: ['$http', '$route', 'apiRoot', function ($http, $route, apiRoot) {
                                    if (state['_getelem']) {
                                        return $http.get(state['_getelem']({ apiRoot: apiRoot, routeParams: $route.current.params })).then(function (response) {
                                            return response.data;
                                        }, function errorCallback(data) {
                                            return data;
                                        });
                                    }
                                    else {
                                        return {};
                                    }
                                }],
                            extrainfo: ['$http', '$route', 'apiRoot', function ($http, $route, apiRoot) {
                                    if (state['_extrainfo']) {
                                        return $http.get(state['_extrainfo']({ apiRoot: apiRoot, routeParams: $route.current.params })).then(function (response) {
                                            return response.data;
                                        }, function errorCallback(data) {
                                            return data;
                                        });
                                    }
                                    else {
                                        return {};
                                    }
                                }],
                            elems: ['$http', '$route', 'loadMultipleMap', 'apiRoot', function ($http, $route, loadMultipleMap, apiRoot) {
                                    if (state.elems) {
                                        var arr_1 = [];
                                        angular.forEach(state.elems, function (elemToLoad) {
                                            arr_1.push(elemToLoad._url({ apiRoot: apiRoot, routeParams: $route.current.params }));
                                        });
                                        return loadMultipleMap.loadDataFromUrls(arr_1).then(function (responses) {
                                            var ret = {};
                                            var i = 0;
                                            angular.forEach(state.elems, function (elemToLoad) {
                                                ret[elemToLoad.name] = responses[i++].data;
                                            });
                                            return ret;
                                        });
                                    }
                                    else {
                                        return {};
                                    }
                                }]
                        }
                    });
                });
            });
        }]);
    module.run(['$interpolate', '$filter', function (interpolate, $filter) {
            var resources = require('json!mdactions.json');
            angular.forEach(resources, function (resource) {
                var ord = 10;
                angular.forEach($filter('orderBy')(resource.columns, 'order', false), function (value, key) {
                    value.order = ord;
                    value['_order'] = ord;
                    ord += 10;
                });
                angular.forEach(resource.columns, function (value) {
                    if (!value.hasOwnProperty('html')) {
                        var val = '{{row.' + value.name + ' ';
                        if (value.hasOwnProperty('filter')) {
                            val += '| ' + value['filter'];
                        }
                        val += '}}';
                        value['html'] = val;
                    }
                    value['_templ'] = interpolate(value['html']);
                });
                angular.forEach(resource.states, function (state) {
                    if (state.hasOwnProperty('get')) {
                        state['_get'] = interpolate(state.get);
                    }
                    if (state.hasOwnProperty('title')) {
                        state['_title'] = interpolate(state.title);
                    }
                    if (state.hasOwnProperty('extrainfo')) {
                        state['_extrainfo'] = interpolate(state.extrainfo);
                    }
                    if (state.hasOwnProperty('export')) {
                        state['_export'] = interpolate(state.export);
                    }
                    if (state.hasOwnProperty('getelem')) {
                        state['_getelem'] = interpolate(state.getelem);
                    }
                    if (state.hasOwnProperty('getparams')) {
                        state['_getparams'] = interpolate(state.getparams);
                    }
                    if (state.hasOwnProperty('elems')) {
                        angular.forEach(state.elems, function (elemToLoad) {
                            elemToLoad['_url'] = interpolate(elemToLoad.url);
                        });
                    }
                });
                angular.forEach(resource.actions, function (action) {
                    if (action.confirmMessage)
                        action['_confirmMessage'] = interpolate(action.confirmMessage);
                    angular.forEach(action.actions, function (action) {
                        if (action.hasOwnProperty('url')) {
                            action['_url'] = interpolate(action.url);
                        }
                    });
                });
            });
        }]);
    module.factory('globalService', ['$interpolate', '$http', '$mdDialog', '$q', '$injector', '$location', '$log', '$window', 'apiRoot', function (interpolate, $http, $mdDialog, $q, $injector, $location, $log, $window, apiRoot) {
            function confirmActions(msg) {
                return $q(function (resolve) {
                    if (!msg) {
                        setTimeout(function () {
                            resolve(true);
                        }, 10);
                    }
                    else {
                        var confirm_1 = $mdDialog.confirm()
                            .title('Segur que vols realitzar aquesta acció?')
                            .htmlContent(msg)
                            .ariaLabel(msg)
                            .ok('Si, fes-ho!')
                            .cancel('Potser millor deixar-ho!');
                        $mdDialog.show(confirm_1).then(function () {
                            resolve(true);
                        }, function () {
                            resolve(false);
                        });
                    }
                });
            }
            function runAction(obj, elem, id, routeParams, evt) {
                return function (results) {
                    return $q(function (resolve, reject) {
                        var url = null;
                        if (obj.hasOwnProperty('_url')) {
                            var lastResult = results.length > 0 ? results[results.length - 1] : undefined;
                            var resp = !angular.isUndefined(lastResult) && lastResult.hasOwnProperty('data') ? lastResult.data : lastResult;
                            url = obj['_url']({ apiRoot: apiRoot, elem: elem, id: id, routeParams: routeParams, responses: results, resp: resp, result: lastResult });
                        }
                        if (obj.name === 'get' || obj.name === 'post' || obj.name === 'put' || obj.name === 'delete') {
                            $http[obj.name](url, elem).then(function (resp) {
                                resolve([resp]);
                            }, function (err) {
                                reject(err);
                            });
                        }
                        else if (obj.name === 'postNoData') {
                            $http.post(url, null).then(function (resp) {
                                resolve([resp]);
                            }, function (err) {
                                reject(err);
                            });
                        }
                        else if (obj.name === 'postUpload') {
                            var fd = new FormData();
                            var file = elem.TheFile;
                            fd.append('file', file);
                            $http.post(url, fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined }
                            }).then(function (resp) {
                                resolve([resp]);
                            }, function (err) {
                                reject(err);
                            });
                        }
                        else if (obj.name === 'postUploadDirect') {
                            var DialogController = ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                                    $scope.hide = function () { $mdDialog.hide(); };
                                    $scope.cancel = function () { $mdDialog.cancel(); };
                                    $scope.ok = function (value) { $mdDialog.hide(value); };
                                }];
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'templates/uploadFile.html',
                                parent: angular.element(document.body),
                                clickOutsideToClose: false,
                                fullscreen: false
                            }).then(function (file) {
                                var fd = new FormData();
                                fd.append('file', file);
                                $http.post(url, fd, {
                                    transformRequest: angular.identity,
                                    headers: { 'Content-Type': undefined }
                                }).then(function (resp) {
                                    resolve([resp]);
                                }, function (err) {
                                    reject(err);
                                });
                            }, function () {
                                reject();
                            });
                        }
                        else if (obj.name == 'prompt') {
                            var confirm_2 = $mdDialog.prompt()
                                .title(url)
                                .ariaLabel(url)
                                .ok('Ves-hi!')
                                .cancel('Ups...');
                            $mdDialog.show(confirm_2).then(function (result) {
                                resolve({ prompt: result });
                            }, function () {
                                reject();
                            });
                        }
                        else if (obj.name === 'message') {
                            var alert_1 = $mdDialog.alert()
                                .title('Info de la resposta')
                                .textContent(url)
                                .ariaLabel(url)
                                .ok('Ok!');
                            $mdDialog.show(alert_1).then(function () {
                                resolve({ message: true });
                            }, function () {
                                resolve({ message: false });
                            });
                        }
                        else if (obj.name === 'HTMLmessage') {
                            var alert_2 = $mdDialog.alert()
                                .title('Info de la resposta')
                                .htmlContent(url)
                                .ariaLabel(url)
                                .ok('Ok!');
                            $mdDialog.show(alert_2).then(function () {
                                resolve({ message: true });
                            }, function () {
                                resolve({ message: false });
                            });
                        }
                        else if (obj.name === 'route') {
                            var loc = url;
                            if (evt && evt.ctrlKey == true) {
                                loc = $location.$$absUrl.replace($location.$$path, url);
                                $window.open(loc, '_blank');
                            }
                            else {
                                $location.url(loc);
                            }
                            resolve({ route: loc });
                        }
                        else if (obj.name === 'open_url') {
                            $window.open(url, '_blank', null);
                            resolve({ open_url: url });
                        }
                        else if (obj.name === 'refresh') {
                            resolve({ refresh: true });
                        }
                        else if (obj.name === 'back') {
                            $window.history.back();
                            resolve({ goback: true });
                        }
                        else {
                            console.log('?', obj.name, obj.url);
                            resolve({ unknown: obj.name });
                        }
                    });
                };
            }
            var promiseSerial = function (funcs) { return funcs.reduce(function (promise, func) { return promise.then(function (result) { return func(result).then(Array.prototype.concat.bind(result)); }); }, $q.resolve([])); };
            return {
                consumeAction: function (action, id, elem, routeParams, evt) {
                    var deferred = $q.defer();
                    var confirmMessage = null;
                    if (action.hasOwnProperty('_confirmMessage'))
                        confirmMessage = action['_confirmMessage']({ id: id, elem: elem, routeParams: routeParams });
                    confirmActions(confirmMessage).then(function (resp) {
                        if (!resp) {
                            action['active'] = true;
                            deferred.resolve({ processed: true, elem: null, responses: null, error: null, refresh: false });
                        }
                        else {
                            var promises_1 = [];
                            angular.forEach(action.actions, function (obj) {
                                promises_1.push(runAction(obj, elem, id, routeParams, evt));
                            });
                            promiseSerial(promises_1).then(function (responses) {
                                var refreshObj = _.find(responses, function (el) { return el.hasOwnProperty('refresh'); });
                                var refresh = angular.isUndefined(refreshObj) ? false : refreshObj['refresh'];
                                var newElemObj = _.find(responses, function (el) { return el.hasOwnProperty('data'); });
                                var newElem = angular.isUndefined(newElemObj) ? null : newElemObj['data'];
                                action['active'] = true;
                                deferred.resolve({ processed: true, elem: newElem, responses: responses, error: null, refresh: refresh });
                            }).catch(function (errors) {
                                console.log(errors);
                                action['active'] = true;
                                deferred.reject(errors);
                            });
                        }
                    });
                    return deferred.promise;
                }
            };
        }]);
    module.directive('defaultModel', [function () {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: { default: '=defaultModel' },
                link: function (scope, element, attributes, ngModel) {
                    ngModel.$formatters.push(function (modelValue) {
                        if (angular.isUndefined(modelValue) || modelValue == null) {
                            modelValue = scope.default;
                        }
                        return modelValue;
                    });
                }
            };
        }]);
    module.controller('GenericListController', [
        '$rootScope',
        '$scope',
        '$http',
        '$route',
        '$location',
        '$filter',
        '$window',
        '$httpParamSerializer',
        '$q',
        '$interpolate',
        'hotkeys',
        'sharedProperties',
        'apiRoot',
        'actionFactory',
        'columnFactory',
        'consumer',
        'state',
        'info',
        'elem',
        'elems',
        'extrainfo',
        function ($rootScope, $scope, $http, $route, $location, $filter, $window, $httpParamSerializer, $q, $interpolate, hotkeys, sharedProperties, apiRoot, actionFactory, columnFactory, consumer, state, info, elem, elems, extrainfo) {
            hotkeys.bindTo($scope).add({ combo: 'n', description: 'Go to next page', callback: function () { $scope.query.page++; } });
            hotkeys.bindTo($scope).add({ combo: 'p', description: 'Go to previous page', callback: function () { $scope.query.page--; } });
            hotkeys.bindTo($scope).add({ combo: 'r', description: 'Reload data', callback: function () { $scope.getResource(); } });
            $scope.querySearch = function (query, value, returnFiled) {
                var parent = state['parent'];
                var q = parent.querys[query];
                if (!q) {
                    console.error("query '" + query + "' doesn't exists in " + parent.name + "!");
                    return $q(function (resolve) {
                        setTimeout(function () {
                            resolve([{ Id: "query '" + query + "' doesn't exists in " + parent.name + "!" }]);
                        }, 100);
                    });
                }
                var url = $interpolate(q)({ apiRoot: apiRoot, elem: $scope.elem, search: value });
                return $http.get(url).then(function (response) {
                    if (returnFiled && response.data.hasOwnProperty(returnFiled))
                        return response.data[returnFiled];
                    return response.data;
                });
            };
            $scope.populate = function (qs) {
                for (var fld in $scope.query) {
                    if (fld in qs) {
                        $scope.query[fld] = qs[fld];
                    }
                }
                for (var fld in qs) {
                    if (!(fld in $scope.query)) {
                        $scope.elem[fld] = qs[fld];
                    }
                }
            };
            $scope.setupView = function () {
                var qs = $location.search();
                $scope.populate(qs);
                $scope.getResource();
            };
            $scope.$on('$routeUpdate', function () {
                $scope.setupView();
            });
            $scope.elem = {};
            $scope.query = {
                filter: null,
                page: 1,
                Skip: 0,
                Take: 10,
                OrderBy: info.orderBy
            };
            var qs = $location.search();
            $scope.populate(qs);
            $scope.showFilter = false;
            $scope.filtreForm = state.filter;
            $scope.hasFilter = !!$scope.filtreForm;
            $scope.actions = state.elemActions;
            $scope.numact = state.numact;
            $scope.gactions = state.actions;
            $scope.elements = elem;
            $scope.elems = elems;
            $scope.info = info;
            $scope.export = state.export;
            $scope.extrainfo = extrainfo;
            $scope.state = state.state;
            $scope.state['title'] = state['_title'] ? state['_title']({ apiRoot: apiRoot, routeParams: $route.current.params, elem: elem, elems: elems }) : info.title;
            $rootScope.title = $scope.state['title'];
            $scope.st = state;
            $scope.routeParams = $route.current.params;
            $scope.toInt = function (value) {
                return parseInt(value);
            };
            if (state.columns) {
                angular.forEach(info.columns, function (value) {
                    value.active = false;
                    value.order = 0;
                });
                var ord_1 = 10;
                angular.forEach(state.columns, function (value) {
                    var found = $filter('filter')(this, { name: value }, true);
                    if (found.length) {
                        found[0].active = true;
                        found[0].order = ord_1;
                        ord_1 += 10;
                    }
                }, info.columns);
            }
            else {
                angular.forEach(info.columns, function (value) {
                    value.active = value['_active'];
                    value.order = value['_order'];
                });
                if (state.state.hasOwnProperty('columnsToRemove')) {
                    angular.forEach(state.state.columnsToRemove, function (value) {
                        var found = $filter('filter')(this, { name: value }, true);
                        if (found.length) {
                            found[0].active = false;
                        }
                    }, info.columns);
                }
                $scope.columns = info.columns;
            }
            $scope.$on('naction', function (event, action, id, evt) {
                var elem = null;
                var elemIndex = -1;
                var i = 0, len = $scope.elements.Results.length;
                for (; i < len; i++) {
                    var tmp = $scope.elements.Results[i];
                    var isInt = action['isInt'];
                    if ((isInt && parseInt(tmp.Id) === parseInt(id)) || (!isInt && tmp.Id === id)) {
                        elemIndex = i;
                        elem = tmp;
                        break;
                    }
                }
                var promise = consumer.consumeAction(action, id, elem, $route.current.params, evt);
                promise.then(function (retVal) {
                    if (retVal.processed) {
                        if (retVal.refresh) {
                            $scope.getResource();
                        }
                        else if (retVal.elem && elemIndex >= 0) {
                            $scope.elements.Results[elemIndex] = retVal.elem;
                            actionFactory.updateItemActions(info, $scope.actions, id);
                        }
                        return;
                    }
                    console.log('Unhandled action: ', action);
                    action['active'] = true;
                }, function (reason) {
                    console.log('Failed', reason);
                }, function (update) {
                    console.log('Got notification', update);
                });
            });
            $scope.$watch('query.filter', function (newValue, oldValue) {
                if (newValue == '')
                    newValue = null;
                if (newValue !== oldValue)
                    $location.search('filter', newValue);
            });
            $scope.$watch('query.Take', function (newValue, oldValue) {
                if (newValue !== oldValue)
                    $location.search('Take', newValue);
            });
            $scope.$watch('query.OrderBy', function (newValue, oldValue) {
                if (newValue !== oldValue)
                    $location.search('OrderBy', newValue);
            });
            var maxPages = function () {
                if (!$scope.elements.Results)
                    return 999999;
                return $scope.elements.Total > 0 ? Math.ceil($scope.elements.Total / ($scope.query.Take > 0 ? $scope.query.Take : 1)) : 1;
            };
            $scope.$watch('query.page', function (newValue, oldValue) {
                if (newValue === oldValue)
                    return;
                if (newValue < 1) {
                    $scope.query.page = 1;
                }
                else if (newValue > maxPages()) {
                    $scope.query.page = maxPages();
                }
                else {
                    $location.search('page', newValue);
                }
            });
            $scope.selected = [];
            $scope.onColumnSort = function (indexFrom, indexTo) {
                var actives = $filter('filter')(info.columns, { active: true }, true);
                var ordered = $filter('orderBy')(actives, 'order', false);
                var elemFrom = ordered[indexFrom];
                var elemTo = ordered[indexTo];
                var newOrder = elemTo.order;
                if (indexFrom > indexTo)
                    newOrder--;
                else
                    newOrder++;
                elemFrom.order = newOrder;
                var ord = 10;
                angular.forEach($filter('orderBy')(actives, 'order', false), function (value, key) {
                    value.order = ord;
                    ord += 10;
                });
            };
            $scope.clearFilter = function () {
                var newQuery = {
                    filter: null,
                    page: 1,
                    Skip: 0,
                    Take: $scope.query.Take,
                    OrderBy: $scope.query.OrderBy
                };
                $scope.elem = {};
                $scope.query = newQuery;
                $location.search($scope.elem);
            };
            $scope.applyFilter = function () {
                $location.search($scope.elem);
            };
            $scope.exportResource = function () {
                var url = "";
                if (state['_export'])
                    url = state['_export']({ apiRoot: apiRoot, routeParams: $route.current.params });
                else
                    return;
                var qry = angular.copy($scope.query);
                delete qry.page;
                delete qry.filter;
                qry.Skip = 0;
                qry.Take = 999999;
                qry.format = 'csv';
                for (var fld in $scope.elem) {
                    qry[fld] = $scope.elem[fld];
                }
                var query = [];
                if (state['_getparams']) {
                    qry.subQry = state['_getparams']({ apiRoot: apiRoot, routeParams: $route.current.params });
                }
                if ($scope.query.filter) {
                    query.push($scope.query.filter);
                }
                if (query.length > 0) {
                    qry.q = query.toString();
                }
                var qs = $httpParamSerializer(qry);
                var delimit = (url.indexOf('?') == -1) ? '?' : '&';
                url += delimit + qs;
                delimit = '&';
                $window.open(url, '_blank');
            };
            $scope.getResource = function () {
                var url = "";
                if (state['_get'])
                    url = state['_get']({ apiRoot: apiRoot, routeParams: $route.current.params });
                var qry = angular.copy($scope.query);
                delete qry.page;
                delete qry.filter;
                qry.Skip = ($scope.query.page - 1) * $scope.query.Take;
                for (var fld in $scope.elem) {
                    qry[fld] = $scope.elem[fld];
                }
                var query = [];
                if (state['_getparams']) {
                    qry.subQry = state['_getparams']({ apiRoot: apiRoot, routeParams: $route.current.params });
                }
                if ($scope.query.filter) {
                    query.push($scope.query.filter);
                }
                if (query.length > 0) {
                    qry.q = query.toString();
                }
                var isGet = true;
                if (isGet) {
                    var qs_1 = $httpParamSerializer(qry);
                    var delimit = (url.indexOf('?') == -1) ? '?' : '&';
                    url += delimit + qs_1;
                    delimit = '&';
                    $scope.promise = $http.get(url).then(function (response) {
                        var theIds = [];
                        angular.forEach(response.data.Results, function (value) {
                            this.push(value.Id);
                        }, theIds);
                        $scope.promise = actionFactory.complementActions(info, $scope.actions, theIds);
                        $scope.elements = response.data;
                        columnFactory.complementColumns(info, $scope.elements.Results);
                    }, function errorCallback(data) {
                        console.log(data);
                    });
                }
                else {
                    $scope.promise = $http.post(url, qry).then(function (response) {
                        var theIds = [];
                        angular.forEach(response.data.Results, function (value) {
                            this.push(value.Id);
                        }, theIds);
                        $scope.promise = actionFactory.complementActions(info, $scope.actions, theIds);
                        $scope.elements = response.data;
                        columnFactory.complementColumns(info, $scope.elements.Results);
                    }, function errorCallback(data) {
                        console.log(data);
                    });
                }
            };
            $scope.setupView();
        }
    ]);
    module.controller('GenericNewController', [
        '$rootScope',
        '$scope',
        '$http',
        '$route',
        '$compile',
        '$location',
        '$filter',
        'sharedProperties',
        'apiRoot',
        'actionFactory',
        'consumer',
        'state',
        'info',
        'elem',
        'elems',
        'extrainfo',
        function ($rootScope, $scope, $http, $route, $compile, $location, $filter, sharedProperties, apiRoot, actionFactory, consumer, state, info, elem, elems, extrainfo) {
            $scope.actions = state.elemActions;
            $scope.elem = {};
            $scope.elems = elems;
            $scope.extrainfo = extrainfo;
            $scope.state = state.state;
            $scope.state['title'] = state['_title'] ? state['_title']({ apiRoot: apiRoot, routeParams: $route.current.params, elem: elem, elems: elems }) : info.title;
            $rootScope.title = $scope.state['title'];
            $scope.st = state;
            $scope.routeParams = $route.current.params;
            $scope.toInt = function (value) {
                return parseInt(value);
            };
            var apiBaseUrl = sharedProperties.getApiBaseUrl();
            $scope.acSource = function (query) {
                return $http.get(apiBaseUrl + query).then(function (response) {
                    return response.data.Results;
                });
            };
            $scope.$on('naction', function (event, action, id, evt) {
                $scope.error = false;
                var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params, evt);
                promise.then(function (retVal) {
                    if (retVal.processed && retVal.refresh && retVal.elem) {
                        $scope.elem = retVal.elem;
                        actionFactory.updateItemActions(info, state.elemActions, id);
                    }
                }, function (reason) {
                    $scope.error = true;
                    $scope.errorMessage = sharedProperties.getErrorMessage(reason);
                    console.log('Failed', reason);
                }, function (update) {
                    console.log('Got notification', update);
                });
            });
        }
    ]);
    module.controller('GenericEditController', [
        '$rootScope',
        '$scope',
        '$http',
        '$route',
        '$compile',
        '$location',
        '$filter',
        'sharedProperties',
        'apiRoot',
        'actionFactory',
        'consumer',
        'state',
        'info',
        'elem',
        'elems',
        'extrainfo',
        function ($rootScope, $scope, $http, $route, $compile, $location, $filter, sharedProperties, apiRoot, actionFactory, consumer, state, info, elem, elems, extrainfo) {
            $scope.elemId = info.isInt ? parseInt($route.current.params.id) : $route.current.params.id;
            $scope.actions = state.elemActions;
            $scope.elem = elem;
            $scope.elems = elems;
            $scope.extrainfo = extrainfo;
            $scope.state = state.state;
            $scope.state['title'] = state['_title'] ? state['_title']({ apiRoot: apiRoot, routeParams: $route.current.params, elem: elem, elems: elems }) : info.title;
            $rootScope.title = $scope.state['title'];
            $scope.st = state;
            $scope.routeParams = $route.current.params;
            $scope.toInt = function (value) {
                return parseInt(value);
            };
            var apiBaseUrl = sharedProperties.getApiBaseUrl();
            $scope.acSource = function (query) {
                return $http.get(apiBaseUrl + query).then(function (response) {
                    return response.data.Results;
                });
            };
            actionFactory.complementActions(info, $scope.actions, $scope.elemId);
            $scope.AddElem = function (arr, val) {
                if (!arr)
                    arr = new Array();
                arr.push(val);
                return arr;
            };
            $scope.newGuid = function () {
                var key = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
                $scope.elem.EncryptKey = key;
            };
            $scope.$on('naction', function (event, action, id, evt) {
                $scope.error = false;
                var promise = consumer.consumeAction(action, id, $scope.elem, $route.current.params, evt);
                promise.then(function (retVal) {
                    if (retVal.processed && retVal.refresh && retVal.elem) {
                        $scope.elem = retVal.elem;
                        actionFactory.updateItemActions(info, state.elemActions, id);
                    }
                }, function (reason) {
                    $scope.error = true;
                    $scope.errorMessage = sharedProperties.getErrorMessage(reason);
                    console.log('Failed', reason);
                }, function (update) {
                    console.log('Got notification', update);
                });
            });
        }
    ]);
    return module;
});
//# sourceMappingURL=generic.js.map;
